import { useDispatch } from 'react-redux';
import { $actions } from 'Store/ducks';
import { useAsyncAction } from 'Hooks/Common';
import { FolderCreatePayload } from 'Interfaces/Folder';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: FolderCreatePayload) =>
    $actions.folder.createFolder(dispatch, values),
  );
};
